import socket, { invokeRPC } from './socket.js'; // Import both the socket and the new RPC helper

export const signIn = async (email, password) => {
  try {
    const userData = await invokeRPC('authentication', 'signIn', {
      email,
      password,
    })
    return userData
  } catch (error) {
    console.error('Sign-in failed:', error)
    throw error
  }
}

/**
 * Signs the user out by deauthenticating the socket.
 */
export const signOut = async () => {
  await socket.deauthenticate()
}

/**
 * Returns the current authentication state ('authenticated' or 'unauthenticated').
 */
export const authState = () => {
  return socket.authState
}

/**
* Returns the current user's auth token payload, or null if not authenticated.
*/
export const getAuthToken = () => {
  return socket.authToken
}

/**
 * Sets up a listener that fires whenever the socket successfully authenticates.
 * The callback receives the user's auth token payload.
 */
export const authenticated = (callback) => {
  (async () => {
    for await (let event of socket.listener('authenticate')) {
      callback(socket.authToken);
    }
  })()
}

/**
* Sets up a listener that fires whenever the socket deauthenticates.
*/
export const deauthenticated = (callback) => {
  (async () => {
    for await (let event of socket.listener('deauthenticate')) {
      callback(event);
    }
  })()
}

// --- Other RPCs refactored to use invokeRPC ---

export const passwordResetRequest = (email) => {
  return invokeRPC('authentication', 'passwordResetRequest', {
    email: email,
    origin: window.location.origin
  })
}

export const validatePasswordResetToken = (token) => {
  return invokeRPC('authentication', 'validatePasswordResetToken', {
    token: token
  })
}

export const resetPasswordByToken = (token, password) => {
  return invokeRPC('authentication', 'resetPasswordByToken', {
    token: token,
    password: password,
  })
}

export const resetPasswordByFlag = (password) => {
  return invokeRPC('authentication', 'resetPasswordByFlag', {
    password: password,
  })
}

export const poser = (id) => {
  return invokeRPC('authentication', 'poser', {
    id: id
  })
}
